var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"zk-btn"},[_c('canvas',{staticClass:"zk-ripple",on:{"click":_vm.ripple}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }